'use client'

import { DictionaryProvider } from '@/contexts/DictionaryContext'

export default function Providers({ children }: { children: React.ReactNode }) {
  return <DictionaryProvider>{children}</DictionaryProvider>
}
